
// @ts-ignore
import DefaultImage from '@/assets/common_images/default_image.png'
import FilePlus from '@/common/class/FilePlus'
import axios from 'axios'
import { Component, Vue, Ref, PropSync, Watch } from 'vue-property-decorator'
import { createSize } from '@/common/utils'

const imageSize = createSize({ size: 5, type: 'MB' })

const imgMap = {
    url: 'url',
    image: 'image'
}

/**
 * @prop src        图片地址
 * @emit change     图片发生改变
*/
@Component({
    name: 'cover-image'
})
export default class extends Vue {
    @PropSync('src', { default: '' }) private imgSrc!: string
    @Ref('fileRef') private fileEl!: any

    private imgMap = imgMap
    private imgType = ''
    private file = {
        previewUrl: DefaultImage,
        origin: ''
    }
    private inputUrl = ''
    private fetchLoading = false

    private stopWatchSrc!: boolean
    private originSrc!: string

    @Watch('src')
    private watchSrc() {
        if (this.stopWatchSrc) return
        this.file.previewUrl = this.originSrc = this.imgSrc
    }
    created() {
        this.originSrc = ''   
    }
    mounted() {
        this.file.previewUrl = this.originSrc = this.imgSrc || DefaultImage
    }
    onFileSelected({ target }: any) {
        const [ file ] = target.files
        const fp = new FilePlus(file, { size: imageSize })
        if (fp.hasSizeError) {
            return this.$mwarning('图片大小确保在 5mb 以内')
        }
        this.file.previewUrl = URL.createObjectURL(file)    
        this.file.origin = file
        this.$emit('change')
    }
    onReset() {
        this.file = {
            previewUrl: this.originSrc || DefaultImage,
            origin: ''
        }
        this.inputUrl = ''
    }
    async onInputOk() {
        this.fetchLoading = true
        const result = await axios.get(this.inputUrl)
        this.fetchLoading = false
        const contentLength = result.headers['content-length']
        const fp = new FilePlus({ size: contentLength }, { size: imageSize })
        if (fp.hasSizeError) {
            return this.$mwarning('图片大小确保在 5 mb 以内')
        }
        this.file.previewUrl = this.inputUrl
        this.$emit('change')
    }
    onToggleImageWay() {
        this.file = {
            previewUrl: this.originSrc || DefaultImage,
            origin: ''
        }
        this.inputUrl = ''
        this.imgType = ''
    }
    // 暴露给外部使用
    getFile() {
        if (this.imgType === imgMap.url) {
            return this.inputUrl
        } else if (this.imgType === imgMap.image) {
            return this.file.origin
        } else {
            return this.imgSrc
        }
    }
    // 暴露给外部使用
    reset() {
        this.onReset()
    }
    // 暴露给外部使用
    stopWatch() {
        this.stopWatchSrc = true
    }
}
